import { createSlice } from "@reduxjs/toolkit";
import Swal from "sweetalert2";
import { errorHandler } from "../../../helpers/errorHandler";
import {
    Call,
    CallWithFormDataFile,
    downloadBlob,
} from "../../../helpers/fetch";
import {
    startUILoading,
    stopUILoading,
} from "../../actions/administrador/ui/ui";

const initialState = {
    reportData: null,
};

export const SubjectsAndPaymentsByStudents = createSlice({
    name: "SubjectsAndPaymentsByStudents",
    initialState,
    reducers: {
        setReportData: (state, action) => {
            state.reportData = action.payload;
        },
        clearReportData: (state) => {
            state.reportData = initialState.reportData;
        },
    },
});

export const { setReportData, clearReportData } =
    SubjectsAndPaymentsByStudents.actions;

export default SubjectsAndPaymentsByStudents.reducer;

//* Actions
export const startShowSubjectsAndPaymentsByStudent = ({
    cycle,
    is_inscription_cycle,
    status,
    curriculum_id,
    cycle_payment_code,
    is_debtor_documents,
    show_in_grades,
    show_in_status_account,
    account_status_zero,
    enrollments_zero,
    exportFlag = 0,
}) => {
    return async (dispatch) => {
        dispatch(startUILoading());

        const params = new URLSearchParams();

        params.set("export", exportFlag);

        params.set("cycle", `${cycle.year}-${cycle.sub_cycle}`);

        params.set("is_inscription_cycle", is_inscription_cycle);

        if (status.length > 0) {
            params.set("status", status.map((s) => s.value).join(","));
        }

        if (curriculum_id.length > 0) {
            params.set(
                "curriculum_id",
                curriculum_id.map((c) => c.value).join(",")
            );
        }

        if (cycle_payment_code) {
            params.set("cycle_payment_code", cycle_payment_code);
        }

        if (is_debtor_documents === 0 || is_debtor_documents === 1) {
            params.set("is_debtor_documents", Number(is_debtor_documents));
        }

        if (show_in_grades === 0 || show_in_grades === 1) {
            params.set("show_in_grades", Number(show_in_grades));
        }

        if (show_in_status_account === 0 || show_in_status_account === 1) {
            params.set(
                "show_in_status_account",
                Number(show_in_status_account)
            );
        }

        if (account_status_zero === 0 || account_status_zero === 1) {
            params.set("account_status_zero", Number(account_status_zero));
        }

        if (enrollments_zero === 0 || enrollments_zero === 1) {
            params.set("enrollments_zero", Number(enrollments_zero));
        }

        let resp;
        if (!exportFlag) {
            // Búsqueda
            resp = await Call(
                `operators/reports/cycles/subjects-and-payments/by/students`,
                "GET",
                params.toString()
            );

            if (resp.success) {
                if (resp.success?.report?.total == 0) {
                    Swal.fire({
                        icon: "warning",
                        title: "Sin información",
                        text: "No se encontró información de búsqueda con los filtros seleccionados.",
                        toast: true,
                        position: "bottom-end",
                        timer: 8000,
                    });
                }

                dispatch(setReportData(resp.success));
            } else {
                errorHandler(resp);
            }
        } else {
            // Exportar a Excel
            resp = await CallWithFormDataFile(
                `operators/reports/cycles/subjects-and-payments/by/students`,
                "GET",
                params.toString()
            );

            downloadBlob(
                resp,
                `Reporte de materias y pagos de alumnos por ciclo ${cycle.year}-${cycle.sub_cycle}`
            );
        }

        dispatch(stopUILoading());
    };
};
